/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


 document.addEventListener("DOMContentLoaded", function () {
    const rteDivs = document.querySelectorAll('.rte');
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    rteDivs.forEach(rte => {
      const paragraphs = rte.querySelectorAll('p');

      paragraphs.forEach(p => {
        const content = p.textContent.trim();

        // Checks if it's a valid email
        if (emailRegex.test(content)) {
          // Creates the link
          const a = document.createElement('a');
          a.href = `mailto:${content}`;
          a.textContent = content;
          a.style.textDecoration = "none";
          a.style.borderBottom = "1px solid white";
          a.style.paddingBottom = "2px";
          a.style.color = "white";
          
      
          p.innerHTML = ''; 
          p.appendChild(a);
        }
      });
    });
  });


  document.addEventListener('DOMContentLoaded', () => {
  function isInlineShopifyForm(el) {
    return !!(el && el.closest && el.closest('[data-forms-id], [data-form-root="true"]'));
  }

  function resetInlineFormHost(el) {
    if (!el || !el.style) return;
    el.style.position = 'static';
    el.style.inset = 'auto';
    el.style.top = 'auto';
    el.style.left = 'auto';
    el.style.right = 'auto';
    el.style.bottom = 'auto';
    el.style.transform = 'none';
    el.style.zIndex = 'auto';
    el.style.width = '100%';
    el.style.display = 'block';
  }

  function injectInlineFormTwoColumnStyles(embed) {
    if (!embed || !embed.shadowRoot) return;
    if (!/fashion-monkey-designer-sales/i.test(window.location.pathname)) return;

    var shadow = embed.shadowRoot;
    if (shadow.getElementById('luisa-inline-form-two-col')) return;

    var styleEl = document.createElement('style');
    styleEl.id = 'luisa-inline-form-two-col';
    styleEl.textContent = [
      '@media screen and (min-width: 769px) {',
      '  form[data-testid="form"],',
      '  form[class*="_formFieldset_"] {',
      '    display: grid !important;',
      '    grid-template-columns: 1fr 1fr !important;',
      '    column-gap: 16px !important;',
      '    row-gap: 12px !important;',
      '    align-items: start !important;',
      '  }',
      '  form[data-testid="form"] > [class*="_formFieldContainer_"]:has(#email),',
      '  form[data-testid="form"] > [class*="_consentCheckboxContainer_"],',
      '  form[data-testid="form"] > [class*="_formPhoneInputContainer_"],',
      '  form[data-testid="form"] > [class*="_checkboxFieldSet_"],',
      '  form[data-testid="form"] > button,',
      '  form[data-testid="form"] > [class*="Submit"],',
      '  form[data-testid="form"] > [class*="disclaimer"],',
      '  form[data-testid="form"] > p,',
      '  form[data-testid="form"] > div:has(shop-lead-capture) {',
      '    grid-column: 1 / -1 !important;',
      '  }',
      '  form[data-testid="form"] > [class*="_formFieldContainer_"]:has(#first_name),',
      '  form[data-testid="form"] > [class*="_formFieldContainer_"]:has(#last_name) {',
      '    grid-column: auto !important;',
      '    width: 100% !important;',
      '    min-width: 0 !important;',
      '  }',
      '}',
      'section[class*="_formHeader_"],',
      '[class*="_formHeader_"] {',
      '  margin: 5px auto 5px !important;',
      '  text-align: center !important;',
      '}',
      '[class*="_formHeader_"] h1,',
      '[class*="_formHeader_"] h2,',
      '[class*="_formHeader_"] h3,',
      '[class*="_formHeader_"] p {',
      '  text-align: center !important;',
      '}',
      '@media screen and (min-width: 769px) {',
      '  fieldset[name="custom#favorite_brands"] [class*="_verticalLayout_"],',
      '  fieldset[name*="favorite_brands"] [class*="_verticalLayout_"] {',
      '    display: grid !important;',
      '    grid-template-columns: 1fr 1fr !important;',
      '    column-gap: 12px !important;',
      '    row-gap: 8px !important;',
      '  }',
      '}'
    ].join('\n');
    shadow.appendChild(styleEl);
  }

  function isFashionMonkeySuccess(root) {
    if (!root) return false;
    var text = (root.textContent || '').replace(/\s+/g, ' ').toLowerCase();
    return (
      text.indexOf("you're on the list") !== -1 ||
      text.indexOf('you are on the list') !== -1 ||
      text.indexOf('thank you for registering') !== -1
    );
  }

  function publishFashionMonkeyLead() {
    if (window.__luisaFashionMonkeyLeadSent) return;
    window.__luisaFashionMonkeyLeadSent = true;

    try {
      sessionStorage.setItem('luisa_fashion_monkey_lead_sent', '1');
    } catch (e) {}

    if (typeof window.fbq === 'function') {
      window.fbq('track', 'Lead', {
        content_name: 'Fashion Monkey Designer Sales',
        content_category: 'Form Signup'
      });
    }

    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      Shopify.analytics.publish('luisa:fashion_monkey_lead', {
        form_id: '1146558',
        content_name: 'Fashion Monkey Designer Sales'
      });
    }
  }

  function watchFashionMonkeyFormLead(embed) {
    if (!embed || !embed.shadowRoot) return;
    if (!/fashion-monkey-designer-sales/i.test(window.location.pathname)) return;
    if (embed.getAttribute('data-luisa-lead-watch') === 'true') return;
    embed.setAttribute('data-luisa-lead-watch', 'true');

    try {
      if (sessionStorage.getItem('luisa_fashion_monkey_lead_sent') === '1') {
        window.__luisaFashionMonkeyLeadSent = true;
      }
    } catch (e) {}

    var shadow = embed.shadowRoot;

    function checkSuccess() {
      if (isFashionMonkeySuccess(shadow) || isFashionMonkeySuccess(embed.parentElement)) {
        publishFashionMonkeyLead();
      }
    }

    checkSuccess();
    var successObserver = new MutationObserver(checkSuccess);
    successObserver.observe(shadow, { childList: true, subtree: true, characterData: true });
  }

  function getFloatingFormStep(host) {
    var appRoot = host && host.shadowRoot && host.shadowRoot.querySelector('#app-embed');
    return (appRoot && appRoot.getAttribute('data-current-step')) || 'tease';
  }

  function isFloatingFormOpen(host) {
    var step = getFloatingFormStep(host);
    return step !== 'tease';
  }

  // Teaser stays pinned left; open form must fill the viewport or it stays clipped/rotated.
  function syncFloatingFormHost(host) {
    if (!host || !host.style || isInlineShopifyForm(host)) return;

    try {
      if (isFloatingFormOpen(host)) {
        Object.assign(host.style, {
          position: 'fixed',
          inset: '0px',
          top: '0px',
          left: '0px',
          right: '0px',
          bottom: '0px',
          width: '100%',
          height: '100%',
          transform: 'none',
          rotate: '0deg',
          padding: '0px',
          zIndex: '2147483647',
          display: 'block'
        });
      } else {
        Object.assign(host.style, {
          position: 'fixed',
          inset: '',
          top: '50%',
          left: '0px',
          right: 'unset',
          bottom: 'unset',
          width: '',
          height: '',
          transform: 'translateY(-74%)',
          rotate: '0deg',
          padding: '',
          zIndex: '2147483647',
          display: 'block'
        });
      }
    } catch (e) {}
  }

  function watchFloatingFormStep(host) {
    if (!host || !host.shadowRoot) return;
    if (host.getAttribute('data-luisa-form-step-watch') === 'true') return;
    host.setAttribute('data-luisa-form-step-watch', 'true');

    syncFloatingFormHost(host);

    var stepObserver = new MutationObserver(function () {
      syncFloatingFormHost(host);
    });

    stepObserver.observe(host.shadowRoot, {
      attributes: true,
      attributeFilter: ['data-current-step', 'class', 'style'],
      childList: true,
      subtree: true
    });
  }

  const floatingFormShadowStyles = `
        /* When the popup is open, kill the rotated left-teaser layout */
        #app-embed[data-current-step="form"],
        #app-embed[data-current-step="success"],
        #app-embed:has([role="dialog"]) {
          position: fixed !important;
          inset: 0 !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          bottom: 0 !important;
          width: 100% !important;
          height: 100% !important;
          max-width: none !important;
          transform: none !important;
          rotate: none !important;
          padding: 0 !important;
          display: block !important;
          overflow: auto !important;
        }

        /* Teaser Button - Updated for new class structure */
        button._teaserContainer_trejf_5,
        button[class*="teaserContainer"] {
          all: unset !important;
          position: fixed !important;
          top: 50% !important;
          left: 0px !important;
          transform: translateY(-74%)!important;
          transform-origin: top left !important;
          background-color: #F1F1F1 !important;
          padding: 12px 14px !important;
          font-size: 16px !important;
          line-height: 100% !important;
          font-family: "Aka-Acid-GeosansLight" !important;
          font-weight: 400 !important;
          color: rgb(0, 0, 0) !important;
          cursor: pointer !important;
          z-index: 2147483647 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 12px !important;
          border: medium !important;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 8px !important;
          min-width: 90px !important;
        }
        
        /* Teaser Message - Updated for new class structure */
        h3._teaserHeading_trejf_28,
        h3[class*="teaserHeading"] {
          all: unset !important;
          color: rgb(0, 0, 0) !important;
          font-size: 16px !important;
          font-weight: 400 !important;
          font-family: "Aka-Acid-GeosansLight" !important;
        }

        /* Close Button - Updated for new class structure */
        span._formCloseButton_1684x_4,
        span[class*="formCloseButton"] {
          all: unset !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 14px !important;
          height: 14px !important;
          border-radius: 50% !important;
          border: 1px solid rgb(0, 0, 0) !important;
          background-color: #fff !important;
          cursor: pointer !important;
        }
        
        /* Make the X icon smaller */
        span._formCloseButton_1684x_4 svg,
        span[class*="formCloseButton"] svg {
          width: 6px !important;
          height: 6px !important;
        }

        span._formCloseButton_1684x_4:hover,
        span[class*="formCloseButton"]:hover {
          color: red !important;
        }

        @media screen and (max-width: 768px) {
          button._teaserContainer_trejf_5,
          button[class*="teaserContainer"] {
            font-size: 12px !important;
            padding-top: 54px !important;
            min-width: 100px !important;
          }

          span._formCloseButton_1684x_4 svg,
          span[class*="formCloseButton"] svg {
            width: 10px !important;
            height: 10px !important;
          }

          span._formCloseButton_1684x_4,
          span[class*="formCloseButton"] {
            all: unset !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: center !important;
            width: 18px !important;
            height: 18px !important;
            border-radius: 50% !important;
            border: 1px solid rgb(0, 0, 0) !important;
            background-color: #fff !important;
            cursor: pointer !important;
          }
        }
      
        h2._textHeading_2aowh_35 {
          color: #000;
          font-family: Aka-Acid-GeosansLight;
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: 100%;
        }
        
        input._formInputField_237zm_7{
          font-family: "Aka-Acid-GeosansLight" !important;
        }

        ._textBody_2aowh_10, span._textBody_2aowh_10, p._textBody_2aowh_10{
            color: #000;
            font-family: Aka-Acid-GeosansLight;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 136%; 
        }
        
        button._formSubmitButton_8skcf_90 {
          color: var(--Button-Color-Text, #F8F6F4);
          font-family: Aka-Acid-GeosansLight;
          font-size: 24px;
          font-style: normal;
          font-weight: 400;
          line-height: 100%; 
          background-color: black;
          border-radius: 0px;
        }
        
        div._formDisclaimer_8skcf_38{
          font-family: "Aka-Acid-GeosansLight" !important;
        }
  `;

  const observer = new MutationObserver(() => {
    // Prefer floating teaser embeds; never treat page inline Forms as the teaser.
    const allFormHosts = Array.from(document.querySelectorAll('shopify-forms-embed, form-embed'));
    allFormHosts.filter(isInlineShopifyForm).forEach(function (el) {
      resetInlineFormHost(el);
      injectInlineFormTwoColumnStyles(el);
      watchFashionMonkeyFormLead(el);
    });

    const formHost = allFormHosts.find((el) => !isInlineShopifyForm(el)) || null;

    if (formHost && formHost.shadowRoot) {
      const shadow = formHost.shadowRoot;

      if (formHost.getAttribute('data-luisa-form-styles') !== 'true') {
        formHost.setAttribute('data-luisa-form-styles', 'true');

        const styleSheet = new CSSStyleSheet();
        styleSheet.replaceSync(floatingFormShadowStyles);
        shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, styleSheet];
      }

      watchFloatingFormStep(formHost);
      syncFloatingFormHost(formHost);
      observer.disconnect();
    } else if (document.querySelector('[data-testid="app-router"]')) {
      // App renders in light DOM (no shadow). Inject global styles once.
      const styleId = 'form-embed-inline-styles';
      if (!document.getElementById(styleId)) {
        const styleEl = document.createElement('style');
        styleEl.id = styleId;
        styleEl.textContent = `
          button._teaserContainer_trejf_5{all:unset!important;position:fixed!important;top:50%!important;left:0!important;transform:translateY(-74%)!important;transform-origin:top left!important;background:#F1F1F1!important;padding:12px 14px!important;font-size:16px!important;line-height:100%!important;font-family:"Aka-Acid-GeosansLight"!important;font-weight:400!important;color:#000!important;cursor:pointer!important;z-index:2147483647!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:12px!important;border:medium!important;box-shadow:rgba(0,0,0,.1) 0 2px 8px!important;min-width:90px!important}
          h3._teaserHeading_trejf_28{all:unset!important;color:#000!important;font-size:16px!important;font-weight:400!important;font-family:"Aka-Acid-GeosansLight"!important}
          span._formCloseButton_1684x_4{all:unset!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:14px!important;height:14px!important;border-radius:50%!important;border:1px solid #000!important;background:#fff!important;cursor:pointer!important}
          span._formCloseButton_1684x_4 svg{width:6px!important;height:6px!important}
          @media(max-width:768px){
            button._teaserContainer_trejf_5{font-size:12px!important;padding-top:54px!important;min-width:100px!important}
            span._formCloseButton_1684x_4{width:18px!important;height:18px!important}
            span._formCloseButton_1684x_4 svg{width:10px!important;height:10px!important}
          }
        `;
        document.head.appendChild(styleEl);
      }
    }

    // Floating teaser only — never pin page inline Forms embeds
    const appEmbed = allFormHosts.find((el) => el.id === 'app-embed' && !isInlineShopifyForm(el))
      || allFormHosts.find((el) => !isInlineShopifyForm(el));

    if (appEmbed && !isInlineShopifyForm(appEmbed)) {
      syncFloatingFormHost(appEmbed);
      watchFloatingFormStep(appEmbed);

      const styleId2 = 'form-embed-inline-styles-app-embed';
      if (!document.getElementById(styleId2)) {
        const styleEl2 = document.createElement('style');
        styleEl2.id = styleId2;
        styleEl2.textContent = `
          #app-embed button._teaserContainer_trejf_5{all:unset!important;position:fixed!important;top:50%!important;left:0!important;transform:translateY(-74%)!important;transform-origin:top left!important;background:#F1F1F1!important;padding:12px 14px!important;font-size:16px!important;line-height:100%!important;font-family:"Aka-Acid-GeosansLight"!important;font-weight:400!important;color:#000!important;cursor:pointer!important;z-index:2147483647!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:12px!important;box-shadow:rgba(0,0,0,.1) 0 2px 8px!important;min-width:90px!important}
          #app-embed h3._teaserHeading_trejf_28{all:unset!important;color:#000!important;font-size:16px!important;font-weight:400!important;font-family:"Aka-Acid-GeosansLight"!important}
          #app-embed span._formCloseButton_1684x_4{all:unset!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:14px!important;height:14px!important;border-radius:50%!important;border:1px solid #000!important;background:#fff!important;cursor:pointer!important}
          #app-embed span._formCloseButton_1684x_4 svg{width:6px!important;height:6px!important}
          @media(max-width:768px){
            #app-embed button._teaserContainer_trejf_5{font-size:12px!important;padding-top:54px!important;min-width:100px!important}
            #app-embed span._formCloseButton_1684x_4{width:18px!important;height:18px!important}
            #app-embed span._formCloseButton_1684x_4 svg{width:10px!important;height:10px!important}
          }
        `;
        document.head.appendChild(styleEl2);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

  

  
 

  
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.custom-store-gallery').forEach(function (gallerySection) {
      const mainSlider = gallerySection.querySelector('.main-image-slider');
      const slides = gallerySection.querySelectorAll('.main-slide');
      const thumbnails = gallerySection.querySelectorAll('.thumbnail-image');
      const track = gallerySection.querySelector('.thumbnails-track');
      const leftArrow = gallerySection.querySelector('.thumb-arrow.left');
      const rightArrow = gallerySection.querySelector('.thumb-arrow.right');
      const mainLeftArrow = gallerySection.querySelector('.main-arrow.left');
      const mainRightArrow = gallerySection.querySelector('.main-arrow.right');

      let currentIndex = 0;

      function goToSlide(index) {
        mainSlider.style.transform = `translateX(-${index * 100}%)`;
        thumbnails.forEach(t => t.classList.remove('active-thumb'));
        if (thumbnails[index]) {
          thumbnails[index].classList.add('active-thumb');
          
        }
        currentIndex = index;
      }

      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', () => goToSlide(index));
      });
   const scroller = gallerySection.querySelector('.thumbnails-track-wrapper');
    if (leftArrow && rightArrow && scroller) {
      leftArrow.addEventListener('click', () => {
        scroller.scrollBy({ left: -scroller.clientWidth, behavior: 'smooth' });
      });
      rightArrow.addEventListener('click', () => {
        scroller.scrollBy({ left: scroller.clientWidth, behavior: 'smooth' });
      });
    }

      if (mainLeftArrow && mainRightArrow) {
        mainLeftArrow.addEventListener('click', () => {
          const newIndex = (currentIndex - 1 + slides.length) % slides.length;
          goToSlide(newIndex);
        });

        mainRightArrow.addEventListener('click', () => {
          const newIndex = (currentIndex + 1) % slides.length;
          goToSlide(newIndex);
        });
      }

      // Swipe support for mobile
      let startX = 0;
      mainSlider.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      });

      mainSlider.addEventListener('touchend', function (e) {
        const endX = e.changedTouches[0].clientX;
        const diff = endX - startX;

        if (diff > 50) {
          const newIndex = (currentIndex - 1 + slides.length) % slides.length;
          goToSlide(newIndex);
        } else if (diff < -50) {
          const newIndex = (currentIndex + 1) % slides.length;
          goToSlide(newIndex);
        }
      });

      goToSlide(0);
    });
  });



  if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        // Collect selected values per option group, prioritizing radios over selects.
        // This avoids hidden mobile selects overriding visible desktop radios.
        const optionGroups = Array.from(this.querySelectorAll('.product-form__input'));
        return optionGroups
          .map((group) => {
            const checkedRadio = group.querySelector('input[type="radio"]:checked');
            if (checkedRadio && checkedRadio.dataset && checkedRadio.dataset.optionValueId) {
              return checkedRadio.dataset.optionValueId;
            }
            const selectedOption = group.querySelector('select option[selected]');
            return selectedOption ? selectedOption.dataset.optionValueId : undefined;
          })
          .filter((id) => typeof id !== 'undefined');
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}


// Initialize variant scopes that are injected dynamically (e.g., quick add drawer)
document.addEventListener('DOMContentLoaded', function(){
  var bindAll = function () {
    if (window.__initVariantScope) {
      document.querySelectorAll('[data-variant-scope]').forEach(function(el){
        var sel = '[data-variant-scope="' + el.getAttribute('data-variant-scope') + '"]';
        window.__initVariantScope(sel);
      });
    }
  };
  bindAll();
  var mo = new MutationObserver(function(){ bindAll(); });
  mo.observe(document.body, { childList: true, subtree: true });
});



  // Wishlist refresh functionality
  document.addEventListener("DOMContentLoaded", function() {
    // Check if we just refreshed from wishlist (using sessionStorage)
    if (sessionStorage.getItem('wishlistToCart') === 'true') {
      // Clear the flag
      sessionStorage.removeItem('wishlistToCart');
      
      // Open cart drawer after a short delay
      setTimeout(function() {
        const cartButton = document.querySelector('[data-cart-toggle]') || 
                          document.querySelector('.cart-toggle') ||
                          document.querySelector('[data-drawer-trigger="cart"]');
        if (cartButton) {
          cartButton.click();
        }
      }, 100);
    }

    // Listen for clicks on "Move to Cart" buttons from wishlist app
    document.addEventListener('click', function(event) {
      // Check if the clicked element or its parent contains "Move to Cart" text
      const target = event.target;
      const text = target.textContent || target.innerText || '';
      
      // Only trigger on specific wishlist "Move to Cart" text
      if ((text.toLowerCase().includes('move to cart') || 
           text.toLowerCase().includes('add to cart')) &&
          (window.location.pathname.includes('/apps/wishlist') || 
           window.location.pathname.includes('/wishlist'))) {
        
        // Prevent the default action first
        event.preventDefault();
        event.stopPropagation();
        
        // Check if the item is available before proceeding
        const productElement = target.closest('[data-product-id]') || 
                              target.closest('.product-item') ||
                              target.closest('[class*="product"]');
        
        if (productElement) {
          // Try to get variant availability info
          const variantId = productElement.getAttribute('data-variant-id') || 
                           productElement.querySelector('[data-variant-id]')?.getAttribute('data-variant-id');
          
          // If we can't determine availability, show a warning
          if (!variantId) {
            alert('Please check product availability before adding to cart. Some sizes may be out of stock.');
            return;
          }
        }
        
        // Set flag before refresh
        sessionStorage.setItem('wishlistToCart', 'true');
        
        // Add a longer delay to allow the wishlist app to process the action
        // Increased delay to prevent "too many attempts" errors
        setTimeout(function() {
          window.location.reload();
        }, 2000);
      }
    });
    
    // Handle wishlist variant availability
    if (window.location.pathname.includes('/apps/wishlist') || 
        window.location.pathname.includes('/wishlist')) {
      
      // Function to hide out-of-stock options
      function hideOutOfStockOptions() {
        const variantPickers = document.querySelectorAll('.wishlist-variant-picker');
        
        variantPickers.forEach(picker => {
          const options = picker.querySelectorAll('option');
          let hasAvailableOptions = false;
          
          options.forEach(option => {
            const inventoryQuantity = parseInt(option.getAttribute('data-inventory_quantity') || '0');
            const inventoryPolicy = option.getAttribute('data-inventory_policy');
            
            // Hide options that are out of stock
            if (inventoryQuantity === 0 && inventoryPolicy === 'DENY') {
              option.style.display = 'none';
              option.disabled = true;
            } else {
              hasAvailableOptions = true;
            }
          });
          
          // If no available options, show a message
          if (!hasAvailableOptions) {
            const noStockMessage = document.createElement('option');
            noStockMessage.text = 'Out of Stock';
            noStockMessage.disabled = true;
            noStockMessage.style.color = '#999';
            picker.appendChild(noStockMessage);
          }
        });
      }
      
      // Run immediately
      hideOutOfStockOptions();
      
      // Also run when new content is loaded (for dynamic wishlist updates)
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            hideOutOfStockOptions();
          }
        });
      });
      
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  });


  // Cart discount code functionality - WORKING VERSION
    function initCartDiscount() {
      const discountInput = document.querySelector('[data-discount-input]');
      const discountButton = document.querySelector('[data-apply-discount]');
      const discountErrorMessage = document.querySelector('[data-discount-error-message]');

      if (!discountInput || !discountButton) return;

      let existingDiscountCodes = [];
      let discountError = false;

      // Apply discount code
      function applyDiscount(discountCode) {
        if (existingDiscountCodes.includes(discountCode)) {
          showDiscountMessage('Discount already applied', 'error');
          return;
        }

        existingDiscountCodes.push(discountCode);
        updateCartDiscounts(existingDiscountCodes.join(','));
      }

      // Update cart with discount codes
      function updateCartDiscounts(discountString) {
        const lastAttemptedDiscount = discountString
          .split(',')
          .filter((c) => c)
          .pop()
          ?.trim();

        showDiscountMessage('Applying discount...', 'loading');

        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            discount: discountString,
          }),
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.text();
          })
          .then((text) => {
            let data;
            try {
              data = JSON.parse(text);
            } catch (e) {
              console.error('Failed to parse cart update response:', text);
              throw new Error('Invalid JSON response from server.');
            }

            if (lastAttemptedDiscount) {
              const wasApplied = data.discount_codes && Array.isArray(data.discount_codes) &&
                data.discount_codes.some((d) => d.code === lastAttemptedDiscount && d.applicable);

              if (!wasApplied) {
                discountError = true;
                existingDiscountCodes = existingDiscountCodes.filter((code) => code !== lastAttemptedDiscount);
                showDiscountMessage('Discount not applicable', 'error');
              } else {
                discountError = false;
                showDiscountMessage('Discount applied successfully!', 'success');
                // Refresh cart to show updated totals
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
              }
            } else {
              discountError = false;
              showDiscountMessage('Discount removed', 'success');
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          })
          .catch((error) => {
            console.error('Error updating cart discounts:', error);
            showDiscountMessage('Error applying discount code', 'error');
          });
      }

      // Show discount messages
      function showDiscountMessage(text, type) {
        if (discountErrorMessage) {
          discountErrorMessage.textContent = text;
          discountErrorMessage.className = 'cart__errors__content cart__errors__inner cart__errors__content--' + type;
          discountErrorMessage.classList.remove('hidden');

          if (type !== 'loading') {
            setTimeout(() => {
              discountErrorMessage.classList.add('hidden');
            }, 3000);
          }
        }
      }

      // Event listeners
      discountButton.addEventListener('click', (event) => {
        event.preventDefault();
        const newDiscountCode = discountInput.value.trim();
        discountInput.value = '';

        if (newDiscountCode) {
          applyDiscount(newDiscountCode);
        }
      });

      discountInput.addEventListener('keypress', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          discountButton.click();
        }
      });
    }

    // Initialize discount functionality when DOM is ready
    document.addEventListener('DOMContentLoaded', function () {
      initCartDiscount();
    });

     // Cart discount code functionality - WORKING VERSION
  function initCartDiscount() {
    const discountInput = document.querySelector('[data-discount-input]');
    const discountButton = document.querySelector('[data-apply-discount]');
    const discountErrorMessage = document.querySelector('[data-discount-error-message]');
    const removeDiscountButton = document.querySelector('[data-remove-discount]');

    if (!discountInput || !discountButton) return;

    let existingDiscountCodes = [];
    let discountError = false;

    // Apply discount code
    function applyDiscount(discountCode) {
      if (existingDiscountCodes.includes(discountCode)) {
        showDiscountMessage('Discount already applied', 'error');
        return;
      }

      existingDiscountCodes.push(discountCode);
      updateCartDiscounts(existingDiscountCodes.join(','));
    }

    // Remove discount code
    function removeDiscount() {
      existingDiscountCodes = [];
      updateCartDiscounts('');
    }

    // Update cart with discount codes
    function updateCartDiscounts(discountString) {
      const lastAttemptedDiscount = discountString
        .split(',')
        .filter((c) => c)
        .pop()
        ?.trim();

      showDiscountMessage('Applying discount...', 'loading');

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          discount: discountString,
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then((text) => {
          let data;
          try {
            data = JSON.parse(text);
          } catch (e) {
            console.error('Failed to parse cart update response:', text);
            throw new Error('Invalid JSON response from server.');
          }

          if (lastAttemptedDiscount) {
            const wasApplied = data.discount_codes && Array.isArray(data.discount_codes) &&
              data.discount_codes.some((d) => d.code === lastAttemptedDiscount && d.applicable);

            if (!wasApplied) {
              discountError = true;
              existingDiscountCodes = existingDiscountCodes.filter((code) => code !== lastAttemptedDiscount);
              showDiscountMessage('Discount not applicable', 'error');
            } else {
              discountError = false;
              showDiscountMessage('Discount applied successfully!', 'success');
              // Refresh cart to show updated totals
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          } else {
            discountError = false;
            showDiscountMessage('Discount removed', 'success');
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        })
        .catch((error) => {
          console.error('Error updating cart discounts:', error);
          showDiscountMessage('Error applying discount code', 'error');
        });
    }

    // Show discount messages
    function showDiscountMessage(text, type) {
      if (discountErrorMessage) {
        discountErrorMessage.textContent = text;
        discountErrorMessage.className = 'cart__errors__content cart__errors__inner cart__errors__content--' + type;
        discountErrorMessage.classList.remove('hidden');

        if (type !== 'loading') {
          setTimeout(() => {
            discountErrorMessage.classList.add('hidden');
          }, 3000);
        }
      }
    }

    // Event listeners
    discountButton.addEventListener('click', (event) => {
      event.preventDefault();
      const newDiscountCode = discountInput.value.trim();
      discountInput.value = '';

      if (newDiscountCode) {
        applyDiscount(newDiscountCode);
      }
    });

    // Remove discount button event listener
    if (removeDiscountButton) {
      removeDiscountButton.addEventListener('click', (event) => {
        event.preventDefault();
        removeDiscount();
      });
    }

    discountInput.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        discountButton.click();
      }
    });
  }

  // Initialize discount functionality when DOM is ready
  document.addEventListener('DOMContentLoaded', function () {
    initCartDiscount();
  });

  // Wishlist Vendor Display Functionality - Get Real Vendor from Product API
  (function() {
    'use strict';
    
    // Function to add vendor to wishlist item
    function addVendorToItem(wishlistItem, vendor) {
      const titleElement = wishlistItem.querySelector('.wihslist-meta h3');
      if (titleElement && vendor) {
        titleElement.setAttribute('data-vendor', vendor);
      }
    }
    
    // Function to fetch vendor from Shopify product API using handle
    async function fetchVendorFromAPI(productUrl) {
      try {
        // Extract product handle from URL
        const urlParts = productUrl.split('/');
        const productHandle = urlParts[urlParts.length - 1].split('?')[0];
        
        const response = await fetch(`/products/${productHandle}.js`);
        
        if (response.ok) {
          const product = await response.json();
          return product.vendor;
        }
      } catch (error) {
        // Silent fail - no vendor found
      }
      return null;
    }
    
    // Function to process all wishlist items
    async function processWishlistItems() {
      const wishlistItems = document.querySelectorAll('.wishlist-page .wishlist-column');
      
      for (const item of wishlistItems) {
        const titleElement = item.querySelector('.wihslist-meta h3 a');
        const productUrl = titleElement?.getAttribute('href');
        
        if (productUrl) {
          const vendor = await fetchVendorFromAPI(productUrl);
          if (vendor) {
            addVendorToItem(item, vendor);
          }
        }
      }
    }
    
    // Function to initialize the script
    function init() {
      // Run immediately
      processWishlistItems();
      
      // Also run when wishlist content changes (for dynamic loading)
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            processWishlistItems();
          }
        });
      });
      
      // Start observing
      const wishlistPage = document.querySelector('.wishlist-page');
      if (wishlistPage) {
        observer.observe(wishlistPage, {
          childList: true,
          subtree: true
        });
      }
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();


   // Mobile Slider Dots for Section Columns
  (function() {
    'use strict';
    
    function initSliderDots() {
      const mobileSliders = document.querySelectorAll('.section-columns .grid--mobile-slider');
      
      mobileSliders.forEach(slider => {
        const gridItems = slider.querySelectorAll('.grid-item');
        const totalSlides = gridItems.length;
        
        if (totalSlides <= 1) return; // No need for dots if only one slide
        
        // Create dots
        createSliderDots(slider, totalSlides);
        
        // Initialize dot tracking
        initDotTracking(slider, totalSlides);
      });
    }
    
    function createSliderDots(slider, totalSlides) {
      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'slider-dots';
      
      for (let i = 0; i < totalSlides; i++) {
        const dot = document.createElement('div');
        dot.className = 'slider-dot';
        if (i === 0) dot.classList.add('active');
        dotsContainer.appendChild(dot);
      }
      
      // Add dots to the section (parent of slider)
      const section = slider.closest('.section-columns');
      if (section) {
        section.appendChild(dotsContainer);
      }
    }
    
    function initDotTracking(slider, totalSlides) {
      const dots = slider.closest('.section-columns').querySelectorAll('.slider-dot');
      const gridItems = slider.querySelectorAll('.grid-item');
      
      function updateDots() {
        const slideWidth = gridItems[0].offsetWidth;
        const currentSlide = Math.round(slider.scrollLeft / slideWidth);
        
        dots.forEach((dot, index) => {
          if (index === currentSlide) {
            dot.classList.add('active');
          } else {
            dot.classList.remove('active');
          }
        });
      }
      
      // Update dots on scroll
      slider.addEventListener('scroll', updateDots);
      
      // Initial update
      updateDots();
    }
    
    // Initialize when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSliderDots);
    } else {
      initSliderDots();
    }
  })();


  (function initGloboMenuBreadcrumb() {
    var STORAGE_KEY = 'luisaMenuPath';
    var HOME_LABEL = 'Home';

    function collectionKey(url) {
      if (!url) return '';
      try {
        var path = url.indexOf('http') === 0 ? new URL(url, window.location.origin).pathname : url;
        var match = path.match(/\/collections\/[^/?#]+/);
        return match ? match[0].replace(/\/$/, '') : path.replace(/\/$/, '');
      } catch (e) {
        return '';
      }
    }

    function prettyTitle(text) {
      return String(text || '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase()
        .replace(/\b\w/g, function (c) { return c.toUpperCase(); });
    }

    function linkLabel(link) {
      if (!link) return '';
      var gmText = link.querySelector('.gm-text');
      var text = (gmText ? gmText.textContent : link.textContent) || '';
      return prettyTitle(text.replace(/\s*submenu\s*$/i, ''));
    }

    function buildCrumbsFromLink(link) {
      if (!link) return [];
      var crumbs = [];
      var node = link.closest('li.gm-item') || link.parentElement;
      var tabCrumb = null;
      var tabContent = link.closest('.gm-tab-content, li.gm-tab-content');

      if (tabContent && tabContent.parentElement) {
        var idx = Array.prototype.indexOf.call(tabContent.parentElement.children, tabContent);
        var tabsRoot = link.closest('.gm-tabs');
        var tabLink = tabsRoot && (
          tabsRoot.querySelector('.gm-tab-links [data-tab-index="' + idx + '"] > a.gm-target') ||
          tabsRoot.querySelector('.gm-tab-links li:nth-child(' + (idx + 1) + ') > a.gm-target')
        );
        if (tabLink) {
          tabCrumb = {
            title: linkLabel(tabLink),
            url: tabLink.getAttribute('href') || ''
          };
        }
      }

      while (
        node &&
        !(node.classList && (node.classList.contains('gm-menu') || node.classList.contains('gm-mobile-menu')))
      ) {
        if (node.matches && node.matches('li.gm-item')) {
          var direct = node.querySelector(':scope > a.gm-target');
          if (direct) {
            var title = linkLabel(direct);
            if (title && title.toLowerCase() !== 'view all') {
              crumbs.push({
                title: title,
                url: direct.getAttribute('href') || ''
              });
            }
          }
        }
        node = node.parentElement;
      }

      crumbs.reverse();

      if (tabCrumb && tabCrumb.title) {
        var exists = crumbs.some(function (c) {
          return c.title.toLowerCase() === tabCrumb.title.toLowerCase();
        });
        if (!exists) {
          crumbs.splice(Math.min(1, crumbs.length), 0, tabCrumb);
        }
      }

      var deduped = [];
      crumbs.forEach(function (crumb) {
        var prev = deduped[deduped.length - 1];
        if (!prev || prev.title.toLowerCase() !== crumb.title.toLowerCase()) {
          deduped.push(crumb);
        }
      });
      return deduped;
    }

    function savePath(crumbs) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(crumbs || []));
      } catch (e) {}
    }

    function readSavedPath() {
      try {
        var raw = sessionStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function handleOf(key) {
      return String(key || '').replace(/^\/collections\//, '');
    }

    function sharedSegments(a, b) {
      var as = handleOf(a).split('-');
      var bs = handleOf(b).split('-');
      var n = 0;
      while (n < as.length && n < bs.length && as[n] === bs[n]) n++;
      return n;
    }

    function menuCollectionLinks() {
      var links = [];
      var menus = document.querySelectorAll('.gm-menu, .gm-mobile-menu, [class*="gm-menu"]');
      Array.prototype.forEach.call(menus, function (menu) {
        Array.prototype.forEach.call(menu.querySelectorAll('a.gm-target[href*="/collections/"]'), function (a) {
          links.push(a);
        });
      });
      if (!links.length) {
        Array.prototype.forEach.call(document.querySelectorAll('a.gm-target[href*="/collections/"]'), function (a) {
          links.push(a);
        });
      }
      return links;
    }

    function crumbsFromRelatedMenu(currentKey, currentTitle, currentUrl) {
      var currentHandle = handleOf(currentKey);
      if (!currentHandle) return [];

      var bestScore = 1;
      var bestLink = null;

      menuCollectionLinks().forEach(function (a) {
        var handle = handleOf(collectionKey(a.getAttribute('href')));
        if (!handle || handle === currentHandle) return;
        var score = sharedSegments(currentHandle, handle);
        if (score > bestScore) {
          bestScore = score;
          bestLink = a;
        }
      });

      if (!bestLink) return [];

      var crumbs = buildCrumbsFromLink(bestLink);
      if (!crumbs.length) return [];

      crumbs = crumbs.slice(0, -1);
      crumbs.push({
        title: currentTitle || prettyTitle(currentHandle.replace(/-/g, ' ')),
        url: currentUrl || currentKey
      });
      return crumbs;
    }

    function crumbsFromMenu(currentKey, currentTitle, currentUrl) {
      if (!currentKey) return [];

      var matches = [];
      menuCollectionLinks().forEach(function (a) {
        if (collectionKey(a.getAttribute('href')) === currentKey) {
          matches.push(a);
        }
      });

      if (matches.length) {
        var best = [];
        matches.forEach(function (link) {
          var crumbs = buildCrumbsFromLink(link);
          if (crumbs.length > best.length) best = crumbs;
        });
        return best;
      }

      return crumbsFromRelatedMenu(currentKey, currentTitle, currentUrl);
    }

    function renderBreadcrumb(nav, crumbs) {
      if (!nav || !crumbs || !crumbs.length) return;

      var list = nav.querySelector('.collection-breadcrumb__list');
      if (!list) return;

      var homeUrl = nav.getAttribute('data-home-url') || '/';
      var homeLabel = nav.getAttribute('data-home-label') || HOME_LABEL;

      list.innerHTML = '';

      var homeItem = document.createElement('li');
      homeItem.className = 'collection-breadcrumb__item';
      var homeAnchor = document.createElement('a');
      homeAnchor.className = 'collection-breadcrumb__link';
      homeAnchor.href = homeUrl;
      homeAnchor.textContent = homeLabel;
      homeItem.appendChild(homeAnchor);
      list.appendChild(homeItem);

      crumbs.forEach(function (crumb, index) {
        var isLast = index === crumbs.length - 1;
        var item = document.createElement('li');
        item.className = 'collection-breadcrumb__item';

        if (isLast || !crumb.url) {
          var current = document.createElement('span');
          current.className = 'collection-breadcrumb__link collection-breadcrumb__link--current';
          current.setAttribute('aria-current', 'page');
          current.textContent = crumb.title;
          item.appendChild(current);
        } else {
          var anchor = document.createElement('a');
          anchor.className = 'collection-breadcrumb__link';
          anchor.href = crumb.url;
          anchor.textContent = crumb.title;
          item.appendChild(anchor);
        }

        list.appendChild(item);
      });

      nav.classList.add('is-ready');
    }

    function fallbackCrumbs(nav) {
      var productTitle = nav.getAttribute('data-product-title');
      if (productTitle) {
        return [{ title: productTitle, url: nav.getAttribute('data-product-url') || '' }];
      }
      return [{
        title: nav.getAttribute('data-collection-title') || prettyTitle(document.title),
        url: nav.getAttribute('data-collection-url') || ''
      }];
    }

    function uniqueUrls(urls) {
      var seen = {};
      var out = [];
      urls.forEach(function (url) {
        var key = collectionKey(url);
        if (!key || seen[key]) return;
        seen[key] = true;
        out.push(url);
      });
      return out;
    }

    function crumbsForProduct(nav, saved) {
      var collectionUrl = nav.getAttribute('data-collection-url') || '';
      var collectionTitle = nav.getAttribute('data-collection-title') || '';
      var urls = uniqueUrls(
        ((nav.getAttribute('data-collection-urls') || '') + ',' + collectionUrl)
          .split(',')
          .map(function (url) { return url.trim(); })
          .filter(Boolean)
      );

      if (saved && saved.length > 1) {
        var savedKey = collectionKey(saved[saved.length - 1].url);
        var savedMatches = urls.some(function (url) {
          return collectionKey(url) === savedKey;
        });
        if (savedMatches) return saved.slice();
      }

      if (collectionUrl) {
        var fromContext = crumbsFromMenu(
          collectionKey(collectionUrl),
          collectionTitle,
          collectionUrl
        );
        if (fromContext.length > 1) return fromContext;
      }

      var best = [];
      urls.forEach(function (url) {
        var crumbs = crumbsFromMenu(collectionKey(url), '', url);
        if (crumbs.length > best.length) best = crumbs;
      });
      return best;
    }

    function fillCollectionBreadcrumb(allowFallback) {
      var navs = document.querySelectorAll('[data-collection-breadcrumb]');
      if (!navs.length) return true;

      var allReady = true;

      Array.prototype.forEach.call(navs, function (nav) {
        if (nav.classList.contains('is-ready')) return;

        var productTitle = nav.getAttribute('data-product-title') || '';
        var currentUrl = nav.getAttribute('data-collection-url') || '';
        var currentTitle = nav.getAttribute('data-collection-title') || '';
        var currentKey = collectionKey(currentUrl || window.location.pathname);
        var saved = readSavedPath();
        var crumbs = [];

        if (productTitle) {
          crumbs = crumbsForProduct(nav, saved);
        } else if (saved && saved.length > 1 && collectionKey(saved[saved.length - 1].url) === currentKey) {
          crumbs = saved.slice();
        } else {
          crumbs = crumbsFromMenu(currentKey, currentTitle, currentUrl);
        }

        if (!productTitle && crumbs.length && currentTitle) {
          crumbs[crumbs.length - 1] = {
            title: currentTitle,
            url: currentUrl || crumbs[crumbs.length - 1].url
          };
        }

        if (productTitle) {
          if (crumbs.length > 1) {
            crumbs = crumbs.concat([{ title: productTitle, url: nav.getAttribute('data-product-url') || '' }]);
            renderBreadcrumb(nav, crumbs);
            savePath(crumbs.slice(0, -1));
            return;
          }

          if (allowFallback) {
            var fallback = crumbs.length
              ? crumbs.concat([{ title: productTitle, url: nav.getAttribute('data-product-url') || '' }])
              : fallbackCrumbs(nav);
            renderBreadcrumb(nav, fallback);
            return;
          }

          allReady = false;
          return;
        }

        if (crumbs.length > 1) {
          renderBreadcrumb(nav, crumbs);
          savePath(crumbs);
          return;
        }

        if (allowFallback) {
          renderBreadcrumb(nav, crumbs.length ? crumbs : fallbackCrumbs(nav));
          return;
        }

        allReady = false;
      });

      return allReady;
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('a.gm-target[href]');
      if (!link) return;
      var crumbs = buildCrumbsFromLink(link);
      if (crumbs.length) savePath(crumbs);
    }, true);

    function start() {
      if (fillCollectionBreadcrumb(false)) return;

      var observer = new MutationObserver(function () {
        if (fillCollectionBreadcrumb(false)) observer.disconnect();
      });
      observer.observe(document.body, { childList: true, subtree: true });

      setTimeout(function () {
        observer.disconnect();
        fillCollectionBreadcrumb(true);
      }, 2500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

(function () {
  if (!/\/pages\/newsletter\/?$/.test(window.location.pathname)) return;

  let leadSent = false;
  let formSeen = false;

  function checkNewsletterSuccess() {
    if (leadSent) return;

    const embed = document.querySelector(
      'shopify-forms-embed#app-embed, form-embed#app-embed'
    );

    if (!embed || !embed.shadowRoot) return;

    const root = embed.shadowRoot;

    if (root.querySelector('form')) {
      formSeen = true;
    }

    const text = (root.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    if (!formSeen || !text.includes('welcome to our world')) return;

    const analytics = window.Shopify && window.Shopify.analytics;

    if (!analytics || typeof analytics.publish !== 'function') return;

    leadSent = true;

    analytics.publish('luisa:newsletter_page_lead', {
      form_id: '1230323',
      content_name: 'Newsletter Page Form',
      content_category: 'Form Signup'
    });

    clearInterval(timer);
  }

  const timer = setInterval(checkNewsletterSuccess, 500);

  window.addEventListener('pagehide', function () {
    clearInterval(timer);
  }, { once: true });
})();